import {RouteDefinition} from '../../../routes';
import {CameraBrandListScreen} from './CameraBrandListScreen';
import {CameraBrandEditScreen} from './CameraBrandEditScreen';

export const CameraBrandSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/developer/camera-brand/edit',
        component: CameraBrandEditScreen,
    },
    {
        routerLink: '/developer/camera-brand/edit/:id',
        component: CameraBrandEditScreen,
    },
    {
        routerLink: '/developer/camera-brand',
        component: CameraBrandListScreen,
    },
];
